export const statusEntregasSelect = [
    { text: 'TODOS', value: -1 },
    { text: 'EM ABERTO', value: 0 },
    { text: 'EM APROVAÇÃO', value: 1 },
    { text: 'EM APROVAÇÃO PELO GERENTE', value: 8 },
    { text: 'APROVADA', value: 2 },
    { text: 'REPROVADA', value: 3 },
    { text: 'PENDÊNCIA SAS', value: 5 },
    { text: 'CANCELADA SEM PAGAMENTO', value: 6 },
    { text: 'CANCELADA COM PAGAMENTO', value: 7 }
]
